import { useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from '../../context/LanguageContext';
import { translateError } from '../../utils/errorTranslation';

/**
 * AxiosErrorInterceptor - Automatically translates backend error keys 
 * into user-facing translated text using the current language.
 * 
 * Must be placed INSIDE LanguageProvider in the component tree.
 * Intercepts ALL axios error responses and replaces `detail` with translated text.
 */
const AxiosErrorInterceptor = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.data?.detail && typeof error.response.data.detail === 'string') {
          const originalKey = error.response.data.detail;
          // Only translate if it looks like an error key (lowercase with underscores, no spaces)
          if (/^[a-z][a-z0-9_]*$/.test(originalKey)) {
            error.response.data._originalKey = originalKey;
            error.response.data.detail = translateError(originalKey, t);
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [t]);

  return null;
};

export default AxiosErrorInterceptor;
